<template>
  <div class="topic-sub-view wow fadeIn" data-wow-duration="1s" @mouseleave="onLeave">
    <div class="topic-sub-view-container wow fadeInUp" data-wow-duration="1s">
      <section v-for="group in topicGroups" :key="group.id ?? 'uncategorized'" class="topic-sub-view-group"
               v-show="group.special_subjects?.length">
        <h3>{{ group.name }}</h3>
        <ul>
          <li v-for="item in group.special_subjects" :key="item.id"
              @click="onClickItem(item?.sub_title)">
            <div class="topic-sub-view-card-img-container">
              <img class="topic-sub-view-card-item-img" v-lazy="item?.image ?? ''" alt="" draggable="false"/>
              <p>{{ item?.verbose_name ?? '' }}</p>
            </div>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script setup>

// 传入的动态数据
import {getRequestTopicGroupListData} from "@/services/api.js"
import router from "@/router/router.js"
import store from "@/store/index.js"
// 使用 defineEmits 定义支持的事件
const emit = defineEmits(['send-topic-data'])

const topicGroups = reactive([])

const getTopicListData = async () => {
  try {
    const groups = await getRequestTopicGroupListData()
    topicGroups.splice(0, topicGroups.length, ...groups)
  } catch (error) {
    console.error('Error fetching data:', error)
  }
}

function onClickItem(name) {
  store.commit('setTopicTab', 0)
  router.push({
    name: 'topicServiceList',
    params: {name}
  })
  emit('send-topic-data', false)
}

const onLeave = () => {
  emit('send-topic-data', false)
}

onMounted(() => {
  getTopicListData()
})

</script>

<style scoped lang="less">
.topic-sub-view {
  display: flex;
  width: 100%;
  max-height: 560px;
  background-color: #f8f8f8;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);

  .topic-sub-view-container {
    width: 100%;
    max-height: 560px;
    padding: 45px 135px 50px;
    margin-left: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(600px, 1fr));
    gap: 45px 80px;
    overflow-y: auto;

    .topic-sub-view-group {
      h3 {
        margin: 0 0 35px;
        color: var(--main-color);
        font-size: 16px;
        letter-spacing: 1px;
      }

      ul {
        display: grid;
        padding: 0;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        justify-content: space-between;
        gap: 25px;
        row-gap: 25px;

        li {
          list-style: none;
          cursor: pointer;

          .topic-sub-view-card-img-container {
            position: relative;
            width: 150px;
            height: 96px;
            border-radius: 8px;
            transition: all 0.3s ease;
            z-index: 1;
            overflow: hidden;
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.4);

            .topic-sub-view-card-item-img {
              position: absolute;
              width: 100%;
              height: 100%;
              transition: all 0.3s;
              object-fit: cover;
              object-position: center;
              z-index: 2;
            }

            p {
              position: absolute;
              top: 50%;
              left: 50%;
              width: calc(100% - 24px);
              font-size: 14px;
              color: white;
              letter-spacing: 1px;
              transition: all 0.3s ease;
              z-index: 3;
              transform: translate(-50%, -50%);
              text-align: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            &:hover {
              transform: scale(1.03);

              .topic-sub-view-card-item-img {
                transform: scale(1.2);
              }
            }
          }
        }
      }
    }
  }
}

</style>
